<template>
  <div>
    <InputContainer>
      <template #label>
        {{ $t('Timesheet') }}
        <span v-if="!timesheetsStore.requireTimesheets" class="tw-text-gray-600">
          ({{ $t('optional') }})
        </span>
      </template>
      <template #sub-label>{{ $t('Report specific time worked') }}</template>
      <WdsSelect
        v-model="timesheetsStore.timesheetType"
        data-test="payment-request-timesheet-type-select"
        class="tw-w-[200px] tw-max-w-full"
        :list="timesheetsStore.timesheetTypeOptions"
        :error="timesheetErrors"
        :disabled="!store.isEditable"
      />
    </InputContainer>
    <Transition name="fade">
      <WdsStack
        v-show="TimesheetTypeEnum.NONE !== timesheetsStore.timesheetType.value"
        direction-column
        gap-sm
      >
        <TimesheetInputs
          :timesheet-type="timesheetsStore.timesheetType.value"
          :disabled="!store.isEditable || store.hasNoPaymentRequestPeriodToBill"
          :has-required-timesheet-line-custom-fields="hasRequiredTimesheetLineCustomFields"
        />
      </WdsStack>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, watch } from 'vue'
import { TimesheetTypeEnum } from '@/components/PaymentRequest/enums'
import TimesheetInputs from '@/components/PaymentRequest/TimesheetInputs.vue'
import { useTranslation } from '@/composables/translation'
import { usePaymentRequestStore } from '@/components/PaymentRequest/store/usePaymentRequestStore'
import { useTimesheetStore } from '@/components/PaymentRequest/store/useTimesheetStore'
import { useValidationStore } from '@/components/PaymentRequest/store/useValidationStore'
import InputContainer from '@/components/PaymentRequest/InputContainer.vue'
import { useTimesheetFormStore } from '@/components/Timesheet/store/useTimesheetFormStore'

const { $t } = useTranslation()
const store = usePaymentRequestStore()
const timesheetsStore = useTimesheetStore()
const timesheetFormStore = useTimesheetFormStore()
const validationStore = useValidationStore()

defineProps<{
  hasRequiredTimesheetLineCustomFields?: boolean
}>()

const timesheetErrors = computed(
  () =>
    (validationStore.v$.timesheetType.$errors?.[0]?.$message ||
      validationStore.v$.timesheetSpreadsheetValue?.$errors?.[0]?.$message ||
      validationStore.v$.timesheetFiles?.$errors?.[0]?.$message ||
      validationStore.v$.worksomeTimesheetValue?.$errors?.[0]?.$message) as string,
)

watch(
  () => timesheetsStore.timesheetType.value,
  (updated) => {
    if (updated === TimesheetTypeEnum.TIMESHEET) {
      if (!timesheetFormStore.totalPayableTime) {
        store.paymentRequestForm.billableTime = 0
      }
    }
  },
)
</script>
